import React from 'react';
import PropTypes from 'prop-types';
import { Layer, Rect, Ellipse, Line, Stage, Group } from 'react-konva';
import styles from './styles.less';
import PicabooConstants from '../common/PicabooConstants';

class SelectionOverlay extends React.Component {
  render() {
    if (!this.props.visible) {
      return null;
    }

    const strokeColor = PicabooConstants.COLORS.ACCENT;

    const { pageWidth, pageHeight, containerWidth, containerHeight } =
      this.props;

    const widthBase = Math.max(pageWidth, containerWidth);
    const heightBase = Math.max(pageHeight, containerHeight);

    let leftPageEdge = (widthBase - pageWidth) / 2 + 10;
    let rightPageEdge = leftPageEdge + pageWidth + this.props.marginLeft * 2;
    let topPageEdge = (heightBase - pageHeight) / 2 + 10;
    let bottomPageEdge = topPageEdge + pageHeight + this.props.marginTop * 2;

    leftPageEdge = this.props.isCover
      ? leftPageEdge + this.props.outerAdjustment
      : leftPageEdge;
    rightPageEdge = this.props.isCover
      ? rightPageEdge - this.props.outerAdjustment
      : rightPageEdge;

    //lines below: top, bottom, left, right
    return (
      <div className={styles.selectionOverlay}>
        <Stage
          width={widthBase + 20 + this.props.marginLeft * 2}
          height={heightBase + 20 + this.props.marginTop * 2}
        >
          <Layer>
            {/* Top line */}
            <Line
              points={[leftPageEdge, topPageEdge, rightPageEdge, topPageEdge]}
              stroke={strokeColor}
              strokeWidth={2}
            />
            {/* Bottom line */}
            <Line
              points={[
                leftPageEdge,
                bottomPageEdge,
                rightPageEdge,
                bottomPageEdge,
              ]}
              stroke={strokeColor}
              strokeWidth={2}
            />
            {/* Left line */}
            <Line
              points={[leftPageEdge, topPageEdge, leftPageEdge, bottomPageEdge]}
              stroke={strokeColor}
              strokeWidth={2}
            />
            {/* Right line */}
            <Line
              points={[
                rightPageEdge,
                topPageEdge,
                rightPageEdge,
                bottomPageEdge,
              ]}
              stroke={strokeColor}
              strokeWidth={2}
            />
          </Layer>
        </Stage>
      </div>
    );
  }
}

SelectionOverlay.propTypes = {
  containerWidth: PropTypes.number,
  containerHeight: PropTypes.number,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  marginLeft: PropTypes.number,
  marginTop: PropTypes.number,
  visible: PropTypes.bool,
  outerAdjustment: PropTypes.number,
  isCover: PropTypes.bool,
};

export default SelectionOverlay;
